import type { SfChangeFeedNotification } from '../change-feed/types';

export const notificationStructure: SfChangeFeedNotification = {
  id: '',
  name: 'New Notification',
  crmOrgIds: [],
  criteria: [],
  criteriaLogic: '',
  isActive: true,
  actions: [],
};
